import { utilsModule } from "../utils-module";

utilsModule.factory('printerService',['$q', '$http', 'serverAddress',function($q, $http, serverAddress){

	var cachedList = undefined;

	return {

        /**
         * List all the printers
         * @param {boolean} showUserPrinters if true, shows only the printers enabled for the user
         * @return {promise}
         */
		list : function(showUserPrinters){
			var deferred = $q.defer();

            $http.get(serverAddress.nodeURL + '/Impressoras').then(function(data){
                deferred.resolve(data.data)
            },function(){
                deferred.reject();
            });
            return deferred.promise;
		},

		/**
		 * Cached version of "list". If the cache is empty, this will call list and fill the cache.
		 * After filled, only the cached data will be listed
		 */
		listCached:function(){
            var deferred = $q.defer();

            if (!cachedList) {
                this.list().then(function(listed){
                    cachedList = listed;
                    deferred.resolve(listed);
                },function(){
                    deferred.reject();
                });
            }else{
                deferred.resolve(cachedList);
            }

            return deferred.promise;
        },

        /**
         * Search for a printer in the cached list. If it is not in the cache, search in server (view listCached)
         * @param  {Number} printerId id of the printer to search for
         * @return {Object} the printer object. Undefined, if not found
         */
        getCached: function(printerId){
            var deferred = $q.defer();

            this.listCached().then(function(list){
                for (var i in list){
                    if (list[i] && list[i].id == printerId){
                        deferred.resolve(list[i]);
                        return;
                    }
                }
                deferred.resolve(undefined);
            },function(err){
                deferred.reject(err);
            });

            return deferred.promise;
        }
	};

}]);